import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import React from "react";
import { getUpdateInstruction, WebformFormState } from "./model";
import { OptionalTextAreaTranslationValueInput, TranslationValueReadonly } from "./TranslationValueInnerForm";
import ContactEmailRow from "contact/detail/components/ContactEmailRow";
import MultiEmailInput from "components/ValidatedFields/MultiEmailInput";

export const afterSubmitSection = (
  webformFormState: WebformFormState,
): FormSection => ({
  key: "afterSubmit",
  title: RESX.Webform.AfterSubmitting,
  type: "collapsable",
  fields: [{
    key: "descriptionSuccess",
    label: RESX.Webform.MessageAfterSubmitting,
    isEmpty: webformFormState.descriptionSuccess.length === 0,
    render: () => <TranslationValueReadonly values={webformFormState.descriptionSuccess} />,
    inPageEdit: {
      render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <OptionalTextAreaTranslationValueInput
        submit={submit}
        onChange={onChange}
        values={value}
        isSaving={isSaving}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.descriptionSuccess,
      submitChange: (descriptionSuccess: server.dto.TranslationValue[]) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        descriptionSuccess,
      }),
    }
  }, {
    key: "recipientEmails",
    label: RESX.GeneralLabels.Email,
    isEmpty: webformFormState.recipientEmails.length === 0,
    render: () => <ContactEmailRow
      emailAddresses={webformFormState.recipientEmails}
      emailBlacklisted={false}
    />,
    inPageEdit: {
      initialValue: webformFormState.recipientEmails,
      render: ({ value, onChange, submit, cancel }) => <MultiEmailInput
        validatorKey="recipientEmails"
        value={value}
        onChange={onChange}
        onBlur={() => { }}
        onEnter={submit}
        onEsc={cancel}
        focusOnMount
        maxLength={serverReference.constants.mailAddress.maxEmailLength}
      />,
      fullWidth: true,
      submitChange: (recipientEmails: string) => window.CoreApi.WebformConfiguration.Update({
        ...getUpdateInstruction(webformFormState),
        recipientEmails,
      }),
      type: "confirmOrCancelButton"
    }
  }]
});